<script setup lang="ts" generic="Value">
import ChatDiagnosisTemplateInputItemLayout from './ChatDiagnosisTemplateInputItemLayout.vue';
import SelectorDropdown, {
  type Option,
} from 'theme/components/atoms/SelectorDropdown.vue';
import InputHelperText from 'theme/components/molecules/InputHelperText.vue';

const props = withDefaults(
  defineProps<{
    modelValue: Value;
    title: string;
    name: string;
    error?: ValidationError;
    notes?: string[];
    placeholder?: string;
    options: Option<Value>[];
    inactive: boolean;
  }>(),
  {
    error: undefined,
    notes: () => [],
    placeholder: '',
  }
);

const emit = defineEmits<{
  'update:modelValue': [value: Value];
}>();

const focusing = ref(false);

const wrappedModelValue = computed<Value>({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

const isItemInactive = computed(() =>
  focusing.value ? false : props.inactive
);
</script>

<template>
  <ChatDiagnosisTemplateInputItemLayout
    :title="title"
    :notes="notes"
    :inactive="isItemInactive"
  >
    <template #input>
      <InputHelperText :error="error" :notes="notes">
        <div :class="$style.wrapper">
          <SelectorDropdown
            v-model="wrappedModelValue"
            :options="options"
            :name="name"
            :placeholder="placeholder"
            :class="$style.wrapper__input"
            @focus="focusing = true"
            @blur="focusing = false"
          />
        </div>
      </InputHelperText>
    </template>
  </ChatDiagnosisTemplateInputItemLayout>
</template>

<style lang="scss" module>
.wrapper {
  &__input {
    width: 100%;
  }
}
</style>
